/* BMG: presentation only. The existing configurator remains the source of truth. */
(() => {
  'use strict';
  if (window.BMGPurchaseRefinement) { window.BMGPurchaseRefinement.init(); return; }
  const instances = new Map();
  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const visible = node => !!node && !node.hidden && !node.closest('[hidden]') && getComputedStyle(node).display !== 'none';
  const plain = e => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  function mount(root, setup) {
    if (instances.has(root)) return;
    const abort = new AbortController(), cleanups = [];
    const state = {
      on: (target, name, fn, options = {}) => target?.addEventListener(name, fn, {...options, signal:abort.signal}),
      clean: fn => cleanups.push(fn)
    };
    const dispose = () => { abort.abort(); cleanups.reverse().forEach(fn => { try { fn(); } catch (_) {} }); instances.delete(root); };
    instances.set(root, dispose);
    try { setup(root, state); } catch (error) { dispose(); console.warn('BMG presentation enhancement skipped:', error.message); }
  }
  function gallery(root, state) {
    const grid = root.querySelector('.bmg-print-shop__grid');
    if (!grid) return;
    let frame = 0;
    const moved = new Map(), links = new Map(), labels = new Map();
    const move = (node, parent) => {
      if (!node || !parent || node.parentElement === parent) return;
      if (!moved.has(node)) moved.set(node, {parent:node.parentNode, next:node.nextSibling});
      parent.append(node);
    };
    function scan() {
      frame = 0;
      if (!root.classList.contains('bmg-collection-refined')) return;
      if (!root.classList.contains('bmg-purchase-refined')) root.classList.add('bmg-purchase-refined');
      grid.querySelectorAll('.bmg-print-shop__card').forEach(card => {
        const media = card.querySelector('.bmg-print-shop__media');
        const button = card.querySelector('[data-bmg-view-larger]');
        const link = card.querySelector('.bmg-print-shop__image-link');
        if (button && media) {
          move(button, media);
          button.setAttribute('data-bmg-corner-quick', '');
          if (link && !links.has(link)) {
            links.set(link, ['role','aria-label','aria-haspopup'].map(key => [key,link.getAttribute(key)]));
            link.setAttribute('role','button');
            link.setAttribute('aria-haspopup','dialog');
            link.setAttribute('aria-label','Quick view: ' + (card.dataset.title || 'artwork'));
          }
        }
        const release = card.querySelector('.bmg-print-shop__release-flag');
        if (release && media) { move(release,media); release.setAttribute('data-bmg-corner-release',''); }
      });
      document.querySelectorAll('.bmg-art-viewer [data-viewer-close]').forEach(button => {
        if (!labels.has(button)) labels.set(button, {html:button.innerHTML,label:button.getAttribute('aria-label')});
        text(button, 'Back to gallery ×');
        button.setAttribute('aria-label','Close quick view and return to gallery');
      });
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(scan); };
    const observer = new MutationObserver(schedule);
    observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    state.on(root,'click',event => {
      const link = event.target.closest('.bmg-print-shop__image-link');
      if (!link || !plain(event) || event.defaultPrevented || link.target === '_blank' || link.hasAttribute('download')) return;
      const trigger = link.closest('.bmg-print-shop__card')?.querySelector('[data-bmg-view-larger]');
      if (!trigger || !window.BMGCollectionRefinement) return;
      trigger.click();
      if (document.querySelector('.bmg-art-viewer[open]')) { event.preventDefault(); event.stopPropagation(); }
    },{capture:true});
    state.on(root,'keydown',event => {
      if (event.key === ' ' && event.target.matches('.bmg-print-shop__image-link[role="button"]')) {
        event.preventDefault(); event.target.click();
      }
    });
    state.clean(() => {
      observer.disconnect();cancelAnimationFrame(frame);root.classList.remove('bmg-purchase-refined');
      moved.forEach(({parent,next},node) => {
        node.removeAttribute('data-bmg-corner-quick');node.removeAttribute('data-bmg-corner-release');
        if (parent.isConnected) parent.insertBefore(node,next?.parentNode === parent ? next : null);
      });
      links.forEach((attrs,link) => attrs.forEach(([key,value]) => value === null ? link.removeAttribute(key) : link.setAttribute(key,value)));
      labels.forEach((value,button) => { button.innerHTML=value.html; if(value.label === null)button.removeAttribute('aria-label');else button.setAttribute('aria-label',value.label); });
    });
    scan();
  }
  function product(root, state) {
    const form = root.querySelector('.bmg-product-form');
    const review = document.querySelector('[data-bmg-order-review]');
    const commerce = root.querySelector('.bmg-product-page__commerce');
    if (!form || !review || !commerce) return;
    root.classList.add('bmg-purchase-refined-product');
    let frame = 0, scrollFrame = 0, lastState = '', height = 0;
    const originalLabels = new Map();
    root.querySelectorAll('.bmg-purchase-options > .bmg-option-group > .bmg-product-form__label').forEach((label,index) => {
      if (index > 1) return;
      originalLabels.set(label,label.textContent);
      text(label,(index + 1) + '. ' + label.textContent.trim());
    });
    const summary = document.createElement('section');
    summary.className = 'bmg-selection-summary';
    summary.setAttribute('aria-label','Your current selection');
    summary.innerHTML = '<p class="bmg-selection-summary__heading">3. Your selection</p><p data-bmg-summary-choice></p><p data-bmg-summary-price></p><p class="bmg-selection-summary__delivery" data-bmg-summary-delivery></p><a href="#review-and-purchase">Check delivery and review your selection <span aria-hidden="true">↓</span></a>';
    form.after(summary);
    const bar = document.createElement('aside');
    bar.className = 'bmg-purchase-bar';bar.hidden = true;
    bar.setAttribute('aria-label','Artwork selection shortcut');
    bar.innerHTML = '<div class="bmg-purchase-bar__inner"><div class="bmg-purchase-bar__summary"><span data-bmg-bar-price></span><span data-bmg-bar-selection></span></div><a href="#review-and-purchase" data-bmg-bar-action>Review &amp; purchase</a></div>';
    document.body.append(bar);
    const originalShortcut = root.querySelector('.bmg-review-shortcut');
    const shortcutWasHidden = originalShortcut?.hidden;
    if (originalShortcut) originalShortcut.hidden = true;
    const sizeGroup = root.querySelector('[data-bmg-commerce-sizes]')?.closest('.bmg-option-group');
    const question = document.querySelector('#artwork-question');
    let help;
    if (sizeGroup && question) {
      help = document.createElement('a');help.href = '#artwork-question';help.className='bmg-size-help';
      help.textContent='Help me choose a size or finish';sizeGroup.append(help);
      state.on(help,'click',event => {
        if (!plain(event)) return;
        event.preventDefault();
        const disclosure=question.querySelector('details');if(disclosure)disclosure.open=true;
        const message=question.querySelector('textarea[name="contact[body]"]');
        if(message && !message.value.trim()) {
          const title=root.querySelector('h1')?.textContent.trim() || 'this artwork';
          const selection=review.querySelector('[data-bmg-review-selection]')?.textContent.trim() || '';
          message.value='I would like help choosing a size or presentation for '+title+(selection?' (currently viewing '+selection+')':'')+'.\n\nWall width and height, if known: \nDelivery city and country: \nRoom photo link, optional: ';
        }
        question.scrollIntoView({block:'start',behavior:'auto'});
        question.querySelector('input[name="contact[name]"]')?.focus({preventScroll:true});
      });
    }
    const proofNodes=[];
    document.querySelectorAll('[data-bmg-proof-template]').forEach(template => {
      const target=document.querySelector('[data-bmg-panel="'+template.dataset.bmgProofTemplate+'"] .bmg-presentation-copy');
      if(target) { const node=template.content.firstElementChild.cloneNode(true);target.append(node);proofNodes.push(node); }
    });
    function update() {
      frame=0;
      const ready=root.getAttribute('data-bmg-ready')==='true';
      summary.hidden=!ready;
      const choice=review.querySelector('[data-bmg-review-selection]')?.textContent.trim() || '';
      const finishNode=review.querySelector('[data-bmg-review-frame]');
      const finish=visible(finishNode)?finishNode.textContent.trim():'';
      const price=review.querySelector('[data-bmg-review-price]')?.textContent.trim() || root.querySelector('[data-bmg-price]')?.textContent.trim() || '';
      const size=visible(review.querySelector('[data-bmg-size-enquiry]'));
      const freight=visible(review.querySelector('[data-bmg-international-freight-quote]'));
      const quote=visible(review.querySelector('[data-bmg-quote-purchase]'));
      const add=review.querySelector('[data-bmg-add]');
      const action=size?'Confirm size':freight?'Review freight quote':quote?'Review quote':add?.disabled?'Review selection':'Review & purchase';
      const delivery=size?'Size needs confirmation before ordering.':quote?'Premium framing requires a confirmed quote before ordering.':review.querySelector('[data-bmg-delivery-result-title]')?.textContent.trim() || '';
      const value=[ready,choice,finish,price,action,delivery].join('|');
      if(value!==lastState) {
        lastState=value;
        const complete=[choice,finish].filter(Boolean).join(' · ');
        text(summary.querySelector('[data-bmg-summary-choice]'),complete);
        text(summary.querySelector('[data-bmg-summary-price]'),price);
        text(summary.querySelector('[data-bmg-summary-delivery]'),delivery);
        text(bar.querySelector('[data-bmg-bar-selection]'),complete);
        text(bar.querySelector('[data-bmg-bar-price]'),price);
        text(bar.querySelector('[data-bmg-bar-action]'),action);
      }
      updateBar();
    }
    function updateBar() {
      scrollFrame=0;
      const r=review.getBoundingClientRect();
      const q=question?.getBoundingClientRect();
      const focused=document.activeElement;
      const editing=focused?.matches('input:not([type="hidden"]),textarea,select');
      const shouldShow=innerWidth<=799 && root.getAttribute('data-bmg-ready')==='true' && commerce.getBoundingClientRect().top<innerHeight*.75 && !(r.top<innerHeight-100 && r.bottom>80) && !(q && q.top<innerHeight-100 && q.bottom>80) && !document.querySelector('dialog[open]') && !document.body.classList.contains('bmg-menu-open') && !editing;
      bar.hidden=!shouldShow;
      const nextHeight=shouldShow?bar.getBoundingClientRect().height:0;
      if(Math.abs(nextHeight-height)>1) {height=nextHeight;document.documentElement.style.setProperty('--bmg-purchase-bar-height',height+'px');}
    }
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    const scheduleBar=()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(updateBar);};
    const observer=new MutationObserver(schedule);
    observer.observe(review,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden','disabled']});
    observer.observe(root,{attributes:true,attributeFilter:['data-bmg-ready']});
    state.on(document,'change',schedule);state.on(root,'click',schedule);
    state.on(window,'scroll',scheduleBar,{passive:true});state.on(window,'resize',scheduleBar,{passive:true});
    state.on(document,'focusin',scheduleBar);state.on(document,'focusout',scheduleBar);
    state.on(document,'toggle',scheduleBar,{capture:true});state.on(document,'close',scheduleBar,{capture:true});
    function goToReview(event) {
      if(!plain(event))return;
      event.preventDefault();review.scrollIntoView({block:'start',behavior:'auto'});
      const heading=review.querySelector('h2');
      if(heading) {heading.tabIndex=-1;heading.focus({preventScroll:true});}
      updateBar();
    }
    state.on(bar.querySelector('a'),'click',goToReview);
    state.on(summary.querySelector('a'),'click',goToReview);
    state.clean(()=>{
      observer.disconnect();cancelAnimationFrame(frame);cancelAnimationFrame(scrollFrame);
      summary.remove();bar.remove();help?.remove();proofNodes.forEach(node=>node.remove());
      originalLabels.forEach((value,label)=>text(label,value));
      if(originalShortcut)originalShortcut.hidden=shortcutWasHidden;
      root.classList.remove('bmg-purchase-refined-product');document.documentElement.style.removeProperty('--bmg-purchase-bar-height');
    });
    update();
  }
  function init() {
    if(!document.querySelector('[data-bmg-purchase-refinement]'))return;
    document.querySelectorAll('[data-bmg-catalogue]').forEach(root=>mount(root,gallery));
    document.querySelectorAll('[data-bmg-product-root]').forEach(root=>mount(root,product));
  }
  document.addEventListener('shopify:section:load',()=>{[...instances.values()].forEach(dispose=>dispose());init();});
  document.addEventListener('shopify:section:unload',e=>{[...instances.entries()].forEach(([root,dispose])=>{if(e.target.contains(root))dispose();});});
  window.addEventListener('pageshow',init);
  window.BMGPurchaseRefinement={init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
